import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';

export default class QuoteConversationResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  list(params = { size: 20, offset: 0, conversation_type: 'Email', includes: 'attachment' }) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
